import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { EventService } from 'src/app/services/event.service';

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.page.html',
  styleUrls: ['./subscription.page.scss'],
})
export class SubscriptionPage {
  user;
  mySubscription;
  backButton = false;

  constructor(
    private router: Router,
    private auth: AuthService,
    private eventService: EventService,
    private navCtrl: NavController,
    private dataService: DataService
  ) {}

  ionViewDidEnter() {
    this.auth.getUser().then((user) => {
      this.user = user;
    });
    const subscription = this.dataService.getData('subscription');
    if (subscription) {
      this.mySubscription = subscription;
      this.setSubscriptionFullName();
      this.backButton = true;
    } else {
      this.getSubscription();
    }
    console.log('dia', new Date().getDay());
  }

  getSubscription() {
    this.auth.getSubscription().then((res) => {
      if (!res) {
        this.navCtrl.navigateRoot(['/tecservice-transportec/transportec']);
        return;
      }
      this.mySubscription = res;
      if ((res && this.mySubscription.name === 'PV') || this.mySubscription.status === 1) {
        this.eventService.publish('transportec:subscribed');
        this.navCtrl.navigateRoot(['/tecservice-transportec/transportec']);
      }
      this.setSubscriptionFullName();
    });
  }

  setSubscriptionFullName() {
    switch (this.mySubscription.name) {
      case 'PV':
        this.mySubscription.fullname = 'Pago por viaje';
        break;
      case 'SR':
        this.mySubscription.fullname = 'Redondo Fijo';
        break;
      case 'SRF':
        this.mySubscription.fullname = 'Redondo Flexible';
        break;
      case 'SS':
        this.mySubscription.fullname = 'Sencillo Fijo';
        break;
      case 'SSF':
        this.mySubscription.fullname = 'Sencillo Flexible';
        break;
      // default case
      default:
        this.mySubscription.fullname = 'Pago por viaje';
    }
  }

  next() {
    console.log('goSelection');
    this.router.navigate(['/tecservice-transportec/subscription/selection']);
  }
}
